import { NgModule } from '@angular/core';
import { CategoriesPage } from './categories.page';
import { Routes, RouterModule } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    component: CategoriesPage
  },
  {
    path: 'detail/:id',
    loadChildren: () => import('../category-detail/category-detail.module').then(m => m.CategoryDetailPageModule)
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CategoriesPageRoutingModule { }
